import DocMedsDeliveryInfo from ".";

export default function DocMedsDeliveryInfoExamples() {
  return <DocMedsDeliveryInfo />;
}
